<script>
	const { journeysMap, activeJourneys, availableJourneys, completedJourneys } = require('utilities/journeyUtilities');
	const pubsub = require('events/pubsub');

	module.exports = {
		components: {
			'journey-overview': require('components/journey-overview.vue').default
		},
		data() {
			return {
				journeys: [],
				journeysMap,
				activeJourneys,
				availableJourneys,
				completedJourneys
			};
		},
		mounted() {
			this.setJourneys();
			pubsub.subscribe('journeys-update', this.setJourneys);
		},
		methods: {
			setJourneys() {
				let journeys = [];

				for (const [journeyKey, data] of activeJourneys) {
					journeys.push({
						journeyKey,
						journey: journeysMap.get(journeyKey),
						data,
						status: 'active'
					});
				}

				for (const journeyKey of availableJourneys) {
					journeys.push({
						journeyKey,
						journey: journeysMap.get(journeyKey),
						status: 'available'
					});
				}

				for (const journeyKey of completedJourneys) {
					journeys.push({
						journeyKey,
						journey: journeysMap.get(journeyKey),
						status: 'complete'
					});
				}

				this.journeys = journeys;
			}
		}
	};
</script>
<template>
	<div class="main-content wrapper basecamp">
		<p>Discover all of the ways you can use ReadWorks by exploring these how-tos!</p>
		<ul
			class="journeys-list list-unstyled margin-bottom-medium"
			aria-label="Journeys">
			<li
				v-for="journeyInfo in journeys"
				:key="journeyInfo.journeyKey">
				<journey-overview
					:journey-key="journeyInfo.journeyKey"
					:journey="journeyInfo.journey"
					:status="journeyInfo.status"
					:data="journeyInfo.data"></journey-overview>
			</li>
		</ul>
	</div>
</template>
